import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/shijisun/edu/projects/imui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Button from './index';
import Icon from '../icon/index';
import '../icon/style/index.scss';
import './style/index.scss';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "button"
    }}>{`Button`}</h1>

    <h2 {...{
      "id": "props--methods"
    }}>{`Props & Methods`}</h2>
    <Props of={Button} mdxType="Props" />
    <h2 {...{
      "id": "sizes"
    }}>{`Sizes`}</h2>
    <Playground __position={1} __code={'<Button size=\"s\">Small</Button>\n<Button>Medium</Button>\n<Button size=\"l\">Large</Button>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Button,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Button size="s" mdxType="Button">Small</Button>
    <Button mdxType="Button">Medium</Button>
    <Button size="l" mdxType="Button">Large</Button>
    </Playground>
    <h2 {...{
      "id": "colors"
    }}>{`Colors`}</h2>
    <Playground __position={2} __code={'<Button color=\"default\">Default</Button>\n<Button color=\"primary\">Primary</Button>\n<Button color=\"outline\">Outline</Button>\n<Button color=\"weak\">Weak</Button>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Button,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Button color="default" mdxType="Button">Default</Button>
    <Button color="primary" mdxType="Button">Primary</Button>
    <Button color="outline" mdxType="Button">Outline</Button>
    <Button color="weak" mdxType="Button">Weak</Button>
    </Playground>
    <h2 {...{
      "id": "disabled"
    }}>{`Disabled`}</h2>
    <Playground __position={3} __code={'<Button color=\"default\" disabled={true}>\n  No Click\n</Button>\n<Button color=\"primary\" disabled={true}>\n  No Click\n</Button>\n<Button color=\"outline\" disabled={true}>\n  No Click\n</Button>\n<Button color=\"weak\" disabled={true}>\n  No Click\n</Button>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Button,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Button color="default" disabled={true} mdxType="Button">No Click</Button>
    <Button color="primary" disabled={true} mdxType="Button">No Click</Button>
    <Button color="outline" disabled={true} mdxType="Button">No Click</Button>
    <Button color="weak" disabled={true} mdxType="Button">No Click</Button>
    </Playground>
    <h2 {...{
      "id": "button-with-icon"
    }}>{`Button with Icon`}</h2>
    <Playground __position={4} __code={'() => {\n  const iconStyle = { fontSize: 22, padding: \'0 5px\' }\n  return (\n    <>\n      <Button>\n        <Icon type=\"weixin\" style={iconStyle} />\n        <span>Wechat</span>\n      </Button>\n      <Button color=\"primary\">\n        <Icon type=\"weixin\" style={iconStyle} />\n        <span>Wechat</span>\n      </Button>\n      <Button color=\"outline\">\n        <Icon type=\"weixin\" style={iconStyle} />\n        <span>Wechat</span>\n      </Button>\n      <Button color=\"weak\">\n        <Icon type=\"weixin\" style={iconStyle} />\n        <span>Wechat</span>\n      </Button>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Button,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        const iconStyle = {
          fontSize: 22,
          padding: '0 5px'
        };
        return <>
    <Button mdxType="Button">
        <Icon type="weixin" style={iconStyle} mdxType="Icon" />
        <span>Wechat</span>
    </Button>
    <Button color="primary" mdxType="Button">
        <Icon type="weixin" style={iconStyle} mdxType="Icon" />
        <span>Wechat</span>
    </Button>
    <Button color="outline" mdxType="Button">
        <Icon type="weixin" style={iconStyle} mdxType="Icon" />
        <span>Wechat</span>
    </Button>
    <Button color="weak" mdxType="Button">
        <Icon type="weixin" style={iconStyle} mdxType="Icon" />
        <span>Wechat</span>
    </Button>
    </>;
      }}
    </Playground>
    <h2 {...{
      "id": "links"
    }}>{`Links`}</h2>
    <Playground __position={5} __code={'() => {\n  const iconStyle = { fontSize: 22, padding: \'0 5px\' }\n  return (\n    <>\n      <Button href=\"//ke.qq.com\" target=\"_blank\">\n        <Icon type=\"weixin\" style={iconStyle} />\n      </Button>\n      <Button href=\"//ke.qq.com\" target=\"_blank\" color=\"primary\">\n        <Icon type=\"weixin\" style={iconStyle} />\n      </Button>\n      <Button href=\"//ke.qq.com\" target=\"_blank\" color=\"outline\">\n        <Icon type=\"weixin\" style={iconStyle} />\n      </Button>\n      <Button href=\"//ke.qq.com\" target=\"_blank\" color=\"weak\">\n        <Icon type=\"weixin\" style={iconStyle} />\n      </Button>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Button,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        const iconStyle = {
          fontSize: 22,
          padding: '0 5px'
        };
        return <>
        <Button href="//ke.qq.com" target="_blank" mdxType="Button">
            <Icon type="weixin" style={iconStyle} mdxType="Icon" />
        </Button>
        <Button href="//ke.qq.com" target="_blank" color="primary" mdxType="Button">
            <Icon type="weixin" style={iconStyle} mdxType="Icon" />
        </Button>
        <Button href="//ke.qq.com" target="_blank" color="outline" mdxType="Button">
            <Icon type="weixin" style={iconStyle} mdxType="Icon" />
        </Button>
        <Button href="//ke.qq.com" target="_blank" color="weak" mdxType="Button">
            <Icon type="weixin" style={iconStyle} mdxType="Icon" />
        </Button>
        </>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      